import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaCrown } from "react-icons/fa";
import AuthContext from "../contexts/auth";

export default function FloatingPremiumButton() {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  const isPremium = !!(
    user?.subscriptionExpiresAt &&
    new Date(user.subscriptionExpiresAt) > new Date()
  );

  // Só aparece na home, pra quem ainda não é assinante.
  if (isPremium || location.pathname !== "/") return null;

  return (
    <Link to="/planoanual" className="floating-premium-btn">
      <FaCrown className="floating-premium-crown" />
      <span>
        *Acesso livre a todos Cadernos do site durante um ano
      </span>
    </Link>
  );
}
